import { useMediaQuery, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import {
  contactsFullSelector,
  selectConfigurationParameterById,
  selectFavoritePhoneNumb,
  userContactsSlice,
} from '!core/redux';
import { TrlScreenSummary, TrlTextWithLink } from '»components/atoms';

import { TrlGrid } from '../TrlGrid';
import { columns } from './TrlContact.schema';
import { BoxStyled, TypographyStyled } from './TrlContact.styles';

export const TrlContact = () => {
  const theme = useTheme();
  const dispatch = useDispatch();

  const isMedium = useMediaQuery(theme.breakpoints.up('md'));
  const isLarge = useMediaQuery(theme.breakpoints.up('lg'));
  const isExtraLarge = useMediaQuery(theme.breakpoints.up('xl'));

  const { phoneNumbs } = useSelector(contactsFullSelector);
  const favoritePhoneNumb = useSelector(selectFavoritePhoneNumb);
  const CONTACT_TYPE = useSelector((state) =>
    selectConfigurationParameterById(state, 'CONTACT_TYPE_TMOVEL'),
  ).value;

  const [selectedPhoneNumb, setSelectedPhoneNumb] = useState(null);

  const selectedPhoneNumbToDisplay = selectedPhoneNumb ?? favoritePhoneNumb;

  const handleFavoriteChange = (event) => {
    dispatch(
      userContactsSlice.actions.setFavoriteContactRequest({
        contactId: event.target.value,
        contactType: CONTACT_TYPE,
      }),
    );
  };

  const handleSelectedAccount = (phoneNumb) => {
    setSelectedPhoneNumb(phoneNumb);
  };

  useEffect(() => {
    dispatch(
      userContactsSlice.actions.userContactsRequest({
        contactType: CONTACT_TYPE,
      }),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {!isLarge ? (
        <TrlScreenSummary title="TRLT_UI-CONTACT" hasTopMargin>
          <TrlTextWithLink mainText="TRLT_UI-CONTACT_SELECTOR" />
        </TrlScreenSummary>
      ) : (
        <TrlTextWithLink mainText="TRLT_UI-CONTACT_SELECTOR" />
      )}
      <TrlGrid
        columns={columns({
          handleFavoriteChange,
          favoritePhoneNumb: favoritePhoneNumb?.contactId,
          theme,
          isExtraLarge,
          isLarge,
          isMedium,
        })}
        data={phoneNumbs}
        selectedItem={selectedPhoneNumbToDisplay}
        selectedItemChange={handleSelectedAccount}
        dataItemKey="contactId"
        gridWidth={isLarge && '614px'}
      />
      {!isMedium && !isLarge && (
        <BoxStyled sx={{ display: 'flex' }}>
          <TypographyStyled className="selectedOptionDesc">
            <FormattedMessage id="TRLT_UI-DESCRIPTION" />:
          </TypographyStyled>
          <TypographyStyled className="descriptionValue">
            {selectedPhoneNumbToDisplay?.descr}
          </TypographyStyled>
        </BoxStyled>
      )}
    </>
  );
};
